import React, { useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import DashboardLayout from '../../../Shared/DashboardLayout';
import { baseUrl } from '../../../BaseUrl';
import { useEffect } from 'react';
import { AiFillDelete } from 'react-icons/ai';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const Add = () => {
  const navigate = useNavigate()
  
  const [customerOptions, setCustomerOptions] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [formData, setFormData] = useState({
    customer : null,
    challan_no : '',
    total_amount_with_vat : '',
    vat_amount : '',
    status : '',
  });

  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    },
  });

  const statusOptions = [
    { value: 0, label: 'Ordered' },
    { value: 1, label: 'WIP' },
    { value: 2, label: 'Complete' },
  ];

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const jwtToken = localStorage.getItem("access");
        const response = await axios.get(`${baseUrl}/sales/api/customer/`, {
          headers: {
            Authorization: `JWT ${jwtToken}`,
          },
        });

        console.log('customer',response.data.results)


        setCustomerOptions(
            response.data.results.map((customer) => ({
            value: customer.id,
            label: `${customer.name} | ${customer.company_name}`,
          }))
        );

      } catch (error) {
        console.error('Error fetching inventories', error);
      }
    };
    fetchCustomer();
  }, []);

  const handleCustomerChange = (selectedOption) => {
    const customerId = selectedOption.value; 
    setSelectedCustomer(selectedOption);
    setFormData({
      ...formData,
      customer: customerId, 
    });
  };

  const handleStatusChange = (selectedOption) => {
    setFormData({ ...formData, status: selectedOption.value });
  };

  const handleInputChange = (e, index, type) => {
    const updatedData = { ...formData };
    updatedData[e.target.name] = e.target.value;
    setFormData(updatedData);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const jwtToken = localStorage.getItem("access");
      const response = await axios.post(
        `${baseUrl}/tax_return/api/due-to-vat-deducted-at-source-from-the-supplies-delivered/`,
        formData,  // Your form data
        {
          headers: {
            Authorization: `JWT ${jwtToken}`,
          },
        }
      );
      navigate("/due-to-vat-deducted-at-source-from-the-supplies-delivered-list");
      Toast.fire({
        icon: 'success',
        title: 'Successfully Add',
      });
      }catch (error) {
          if(error.response.data.detail){
              Toast.fire({
              icon: 'error',
              title: `${error.response.data.detail}`,
              });
          }else{
              console.error('Error saving data:', error);
          }

      }
  };

  return (
    <DashboardLayout>
    <div className="px-5 mt-5 mb-10 pb-10">
        <div className=" w-4/4">
        <div className="bg-white p-8 rounded shadow-xl shadow-blue-500/40 w-[100%] mx-auto">
            <form onSubmit={handleSubmit}>
            <div className="flex justify-between rounded border-b-[1px] mb-10 bg-slate-900">
                <div className="mx-5 my-auto">
                <h1 className="uppercase font-semibold text-xl text-[#fff]">Due To Vat Deducted At Source From The Supplies Delivered Add Form</h1>
                </div>
                <div className="my-2 mx-5">
                <button
                    type="submit"
                    className="w-[120px] bg-slate-700 hover:bg-slate-800 border text-white font-medium rounded-lg h-10"
                >
                    Submit
                </button>
                </div>
            </div>

            <div class="flex flex-wrap -mx-3 mb-2">

            <div class="w-full md:w-2/4 px-3 mb-8 border-r-[1px]">
                <div className="flex  md:w-4/4 mx-5 ">
                    <div class="md:w-[40%] my-auto">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-3"  for="inline-full-name">
                            Customer*
                        </label>
                    </div>
                    <div class="md:w-[75%]">
                    <Select
                            id="customer"
                            name="customer"
                            value={selectedCustomer}
                            onChange={handleCustomerChange}
                            options={customerOptions}
                            required
                        />
                    </div>
                </div>
            </div>

            <div class="w-full md:w-2/4 px-3 mb-8">
                <div className="flex  md:w-4/4 mx-5 ">
                    <div class="md:w-[40%] my-auto">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-3"  for="inline-full-name">
                        challan Number*
                        </label>
                    </div>
                    <div class="md:w-[75%]">
                        <input
                            type="text"
                            name="challan_no"
                            id="challan_no"
                            value={formData.challan_no}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 pl-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="Enter challan no"
                            required
                        />   
                    </div>
                </div>
            </div>


            <div class="w-full md:w-4/4 px-3 mb-8">
                <div className="flex  md:w-4/4 mx-5 ">
                    <div class="md:w-[16%] my-auto">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-3"  for="inline-full-name">
                        total amount with vat*
                        </label>
                    </div>
                    <div class="md:w-[84%]">
                        <input
                            type="number"
                            step='0.01'
                            min='0'
                            name="total_amount_with_vat"
                            id="total_amount_with_vat"
                            value={formData.total_amount_with_vat}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 pl-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="Enter total amount with vat"
                            required
                        />   
                    </div>
                </div>
            </div>

            <div class="w-full md:w-2/4 px-3 mb-8 border-r-[1px]">
                <div className="flex  md:w-4/4 mx-5 ">
                    <div class="md:w-[35%] my-auto">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-3"  for="inline-full-name">
                        vat amount*
                        </label>
                    </div>
                    <div class="md:w-[65%]">
                        <input
                            type="number"
                            step='0.01'
                            min='0'
                            name="vat_amount"
                            id="vat_amount"
                            value={formData.vat_amount}
                            onChange={handleInputChange}
                            className="block w-full rounded-md border-0 pl-4 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="Enter Vat Amount"
                            required
                        />   
                    </div>
                </div>
            </div>

            <div class="w-full md:w-2/4 px-3 mb-8">
                <div className="flex  md:w-4/4 mx-5 ">
                    <div class="md:w-[35%] my-auto">
                        <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 mt-3"  for="inline-full-name">
                            status*
                        </label>
                    </div>
                    <div class="md:w-[65%]">
                        <Select
                            id="status"
                            name="status"
                            value={statusOptions.find((option) => option.value === formData.status)}
                            onChange={handleStatusChange}
                            options={statusOptions}
                            required
                        /> 
                    </div>
                </div>
            </div>

            </div>



            </form>
        </div>
        </div>
  </div>
  </DashboardLayout>
  );
};

export default Add;
